import axios from "axios";

const $AUTH_API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "https://cg-main-server.com/",

  headers: {
    "Content-type": "application/x-www-form-urlencoded",
  },
});
export default $AUTH_API;